const roles = {
  listBreadCrumbs: {
    roleManagement: "قائمة إدارة الأدوار",
    roleEdit: "تعديل الدور",
  },
  listFilter: {
    searchRole: "البحث حسب اسم الدور...",
    createRole: "إنشاء دور جديد",
  },
  listRoles: {
    roleManagement: "إدارة الأدوار",
    roleDescription:
      "تساعد الأدوار في إعداد الأذونات بطريقة متسقة، مما يساعد في الحفاظ على أمان ومسؤولية مكان العمل.",
    areYouSure: "هل أنت متأكد أنك تريد حذف هذا الدور؟",
    editRole: "تعديل الدور",
    addNewRole: "إضافة دور جديد",
    deleteRole: "حذف الدور",
    roles: "أدوار",
    role: "الدور",
    roleEn: "اسم الدور (الإنجليزية)",
    roleAr: "اسم الدور (العربية)",
    update: "تحديث",
    numberOfUser: "عدد المستخدمين",
    status: "الحالة",
    action: "الإجراء",
    modules: "الوحدات",
    editPermissions: "تعديل الأذونات",
    updatePermissions: "تحديث الأذونات",
    showingRange: "عرض {from}-{to} من أصل {total} دور",
    actionOptions: {
      edit: "تعديل",
      delete: "حذف",
      disabled: "معطل",
      enabled: "مفعل",
      view: "عرض",
    },
    placeholder: {
      rolePlaceholder: "أدخل الدور",
      noRoleFound: "لم يتم العثور على دور!",
      rolePlaceholderEn: "أدخل اسم الدور (الإنجليزية)",
      rolePlaceholderAr: "أدخل اسم الدور (العربية)",
    },
    grantAdminPrivilegesPromote:
      "هل أنت متأكد أنك تريد منح صلاحيات المسؤول لجميع مستخدمي الدور؟",
    grantAdminPrivilegesDemote:
      "هل أنت متأكد أنك تريد إزالة صلاحيات المسؤول من جميع مستخدمي الدور؟",
  },
};

export default roles;
